import { useTranslation } from "react-i18next";
import { isValidationError } from "../utils/formily";
import { isNetworkError } from "../utils/isNetworkError";
import { errorToast } from "../utils/toasts";

export function useFormSubmitErrorHandler() {
  const { t } = useTranslation(["common"]);
  const offlineMessage = t(($) => $.common["Could not save your changes. Check your connection and try again."]);
  const failureMessage = t(($) => $.common["Could not save your changes. Please try again."]);

  return (error: unknown) => {
    if (isValidationError(error)) {
      return;
    }
    errorToast({ message: isNetworkError(error) ? offlineMessage : failureMessage, error });
  };
}
